function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { createColorStack } from "../colorStack/colorStack";
import chroma from "chroma-js";
var ORANGE = 'orange';
var PINK = 'pink';
var PURPLE = 'purple';
var RED = 'red';
var BLUE = 'blue';
var GREEN = 'green';
export var TEAL = 'teal';
export var ROYAL_BLUE = 'royalblue';
export var MAGENTA = 'magenta';
export function createAccessoryPaletteFromSeed(seedColor) {
    if (chroma.valid(seedColor)) {
        var palette = [];
        var ref = _slicedToArray(chroma(seedColor).hsl(), 3), _ = ref[0], s = ref[1], l = ref[2];
        if (s === 0 || l === 0 || l === 1) {
            console.error("The seed color ".concat(seedColor, " you provided cannot be used to generate a color palette. \n Carina will use the default accessory color palette instead. \n If you would prefer another color, provide one that's not either black, white or grey (having equal levels of rgb)."));
            return null;
        }
        palette = _toConsumableArray(generateRemainingColors(seedColor));
        var colorStacks = [
            createColorStack(palette[0], 'accessoryOne'),
            createColorStack(palette[1], 'accessoryTwo'),
            createColorStack(palette[2], 'accessoryThree'),
            createColorStack(palette[3], 'accessoryFour'),
            createColorStack(palette[4], 'accessoryFive')
        ];
        return {
            colorStacks: colorStacks,
            seedColor: seedColor
        };
    }
}
function generateRemainingColors(seedColor) {
    var seedHue = Math.round(chroma(seedColor).get('hsl.h'));
    var qualPalette = [
        seedColor
    ];
    var qualColorCategories = [
        getColorCategory(seedColor)
    ];
    var nextColorHue = 0;
    var nextColorCategory = '';
    var seedHuePosition = 0.1;
    if (qualColorCategories[0] === RED && seedHue >= 0 && seedHue <= 5) {
        seedHuePosition = (seedHue - 0 + 1) / getColorInfo(qualColorCategories[0]).totalHues;
    } else if (!(seedHue >= 36 && seedHue <= 99)) {
        seedHuePosition = (seedHue - getColorInfo(qualColorCategories[0]).lowerLimit + 1) / getColorInfo(qualColorCategories[0]).totalHues;
    }
    for(var i = 0; i < 5; i++){
        nextColorCategory = getNextColorCategoryUsingPreviousHue(Math.round(chroma(qualPalette[i]).get('hsl.h')), qualColorCategories);
        qualColorCategories.push(nextColorCategory);
        nextColorHue = Math.round(getColorInfo(nextColorCategory).lowerLimit + Math.abs(seedHuePosition * getColorInfo(nextColorCategory).totalHues - 1));
        qualPalette.push(generateNextColor(nextColorHue, nextColorCategory));
    }
    return qualPalette;
}
function getColorCategory(color) {
    var colorHue = Math.round(chroma(color).get('hsl.h'));
    switch(true){
        case colorHue >= 193 && colorHue <= 214:
            return BLUE;
        case colorHue >= 6 && colorHue <= 35:
            return ORANGE;
        case colorHue >= 100 && colorHue <= 174:
            return GREEN;
        case colorHue >= 331 && colorHue <= 340:
            return PINK;
        case colorHue >= 245 && colorHue <= 299:
            return PURPLE;
        case colorHue >= 175 && colorHue <= 192:
            return TEAL;
        case colorHue >= 215 && colorHue <= 244:
            return ROYAL_BLUE;
        case colorHue >= 300 && colorHue <= 330:
            return MAGENTA;
        case colorHue >= 341 && colorHue <= 360 || colorHue >= 0 && colorHue <= 5:
            return RED;
        default:
            return '';
    }
}
function getColorInfo(colorCategory) {
    switch(colorCategory){
        case BLUE:
            return {
                totalHues: 22,
                lowerLimit: 193
            };
        case ORANGE:
            return {
                totalHues: 30,
                lowerLimit: 6
            };
        case GREEN:
            return {
                totalHues: 75,
                lowerLimit: 100
            };
        case PINK:
            return {
                totalHues: 10,
                lowerLimit: 331
            };
        case PURPLE:
            return {
                totalHues: 55,
                lowerLimit: 245
            };
        case TEAL:
            return {
                totalHues: 18,
                lowerLimit: 175
            };
        case ROYAL_BLUE:
            return {
                totalHues: 30,
                lowerLimit: 215
            };
        case MAGENTA:
            return {
                totalHues: 31,
                lowerLimit: 300
            };
        case RED:
            return {
                totalHues: 26,
                lowerLimit: 341
            };
        default:
            return {
                totalHues: 22,
                lowerLimit: 193
            };
    }
}
function getNextColorCategoryUsingPreviousHue(colorHue, qualColorCategories) {
    switch(true){
        case colorHue >= 193 && colorHue <= 214:
            {
                if (!qualColorCategories.includes(ORANGE)) return ORANGE;
                return GREEN;
            }
        case colorHue >= 6 && colorHue <= 35:
            {
                if (!qualColorCategories.includes(BLUE)) return BLUE;
                if (!qualColorCategories.includes(GREEN)) return GREEN;
                return PURPLE;
            }
        case colorHue >= 100 && colorHue <= 174:
            {
                if (!qualColorCategories.includes(PINK)) return PINK;
                return BLUE;
            }
        case colorHue >= 331 && colorHue <= 340:
            {
                if (!qualColorCategories.includes(GREEN)) return GREEN;
                if (!qualColorCategories.includes(BLUE)) return BLUE;
                return PURPLE;
            }
        case colorHue >= 245 && colorHue <= 299:
            {
                if (!qualColorCategories.includes(GREEN)) return GREEN;
                return TEAL;
            }
        case colorHue >= 175 && colorHue <= 192:
            {
                if (!qualColorCategories.includes(ROYAL_BLUE)) return ROYAL_BLUE;
                return MAGENTA;
            }
        case colorHue >= 215 && colorHue <= 244:
            {
                if (!qualColorCategories.includes(TEAL)) return TEAL;
                if (!qualColorCategories.includes(MAGENTA)) return MAGENTA;
                return ORANGE;
            }
        case colorHue >= 300 && colorHue <= 330:
            {
                if (!qualColorCategories.includes(TEAL)) return TEAL;
                return BLUE;
            }
        case colorHue >= 341 && colorHue <= 360 || colorHue >= 0 && colorHue <= 5:
            {
                return GREEN;
            }
        default:
            {
                return BLUE;
            }
    }
}
function generateNextColor(colorHue, colorCategory) {
    switch(colorCategory){
        case BLUE:
            {
                if (colorHue >= 193 && colorHue <= 203) return chroma(colorHue, 0.69, 0.45, 'hsl').hex();
                return chroma(colorHue, 0.69, 0.54, 'hsl').hex();
            }
        case ORANGE:
            {
                if (colorHue >= 6 && colorHue <= 14) {
                    return chroma(colorHue, 0.65, 0.5, 'hsl').hex();
                }
                if (colorHue >= 15 && colorHue <= 20) {
                    return chroma(colorHue, 0.79, 0.57, 'hsl').hex();
                }
                if (colorHue >= 21 && colorHue <= 25) {
                    return chroma(colorHue, 0.73, 0.53, 'hsl').hex();
                }
                if (colorHue >= 26 && colorHue <= 30) {
                    return chroma(colorHue, 0.8, 0.48, 'hsl').hex();
                }
                return chroma(colorHue, 0.9, 0.44, 'hsl').hex();
            }
        case GREEN:
            {
                if (colorHue >= 100 && colorHue <= 110) {
                    return chroma(colorHue, 0.47, 0.43, 'hsl').hex();
                }
                if (colorHue >= 111 && colorHue <= 120) {
                    return chroma(colorHue, 0.47, 0.4, 'hsl').hex();
                }
                if (colorHue >= 121 && colorHue <= 150) {
                    return chroma(colorHue, 0.45, 0.38, 'hsl').hex();
                }
                if (colorHue >= 151 && colorHue <= 165) {
                    return chroma(colorHue, 0.46, 0.37, 'hsl').hex();
                }
                return chroma(colorHue, 0.55, 0.34, 'hsl').hex();
            }
        case PINK:
            return chroma(colorHue, 0.74, 0.45, 'hsl').hex();
        case PURPLE:
            {
                if (colorHue >= 245 && colorHue <= 270) {
                    return chroma(colorHue, 0.55, 0.58, 'hsl').hex();
                }
                if (colorHue >= 271 && colorHue <= 280) {
                    return chroma(colorHue, 0.53, 0.56, 'hsl').hex();
                }
                if (colorHue >= 281 && colorHue <= 285) {
                    return chroma(colorHue, 0.39, 0.51, 'hsl').hex();
                }
                return chroma(colorHue, 0.38, 0.42, 'hsl').hex();
            }
        case TEAL:
            {
                if (colorHue >= 175 && colorHue <= 185) return chroma(colorHue, 0.65, 0.38, 'hsl').hex();
                return chroma(colorHue, 0.65, 0.4, 'hsl').hex();
            }
        case ROYAL_BLUE:
            {
                if (colorHue >= 215 && colorHue <= 230) return chroma(colorHue, 0.68, 0.45, 'hsl').hex();
                return chroma(colorHue, 0.64, 0.45, 'hsl').hex();
            }
        case MAGENTA:
            return chroma(colorHue, 0.74, 0.36, 'hsl').hex();
        default:
            return '';
    }
}
